module.exports = "<p>\n  home page\n</p>\n"